module.exports = __webpack_public_path__ + "img/send.29a8421c.svg";